import { LoginRedirect } from '@sunrise-ui/composites';

export default LoginRedirect;
